module.exports = new __parcel__URL__("objectives_divider_line.8085c53e.png").toString();